import { GET_DEAL,CREATE_DEAL,UPDATE_DEAL, DELETE_DEAL } from '../Actions/actionTypes';
const initial = {
    results: {
      BusinessDeal: null
    }
};
export default (state=initial,action)=>{
    switch (action.type) {
        case CREATE_DEAL:
            return action.payload;
        case GET_DEAL:
            return action.payload;
        case UPDATE_DEAL:
            return action.payload;
        case DELETE_DEAL:
            return {
              results: {
                BusinessDeal: {}
              }
            } ;
        default:
            return state;
    }
}